<template>
  <div>
    <app-spinner v-if="!page_loaded" />
    <template v-else>
      <app-cells><h1 class="title">{{ airline_data.name }}</h1></app-cells>
      <app-tabs :tabs="tabs" />
      <transition name="fade" mode="out-in">
        <router-view :airline="airline_data" @update="fetchData" />
      </transition>
    </template>
  </div>
</template>

<script>
import { getDomesticFlightsAirlinesDetail } from '@/http'
import AppTabs from '@/components/AppTabs'

export default {
  name: 'DatabaseAirlinesDetailLayout',
  components: {AppTabs},
  data() {
    return {
      tabs: [{ name: 'hotels-airlines-general', label: 'General' }],
      page_loaded: false,
      airline_data: {},
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      getDomesticFlightsAirlinesDetail(this.$route.params.id)
        .then(response => {
          this.airline_data = response.data
          this.page_loaded = true
        })
    }
  }
}
</script>
